import { appHttpService } from '@/services/standard/http-service';
import { models } from 'cesg-shared';

class CalculationBudgetService {
  async getAll(
    projectId: string,
  ): Promise<models.ListCalculationBudgetResponse[]> {
    const calculationBudgets = await appHttpService.request
      .url(`/calculation-budgets/${projectId}`)
      .get()
      .json<models.ListCalculationBudgetResponse[]>();
    return calculationBudgets;
  }

  async setupInitialRows(projectId: string) {
    await appHttpService.request
      .url(`/calculation-budgets/setup/${projectId}`)
      .post()
      .res();
  }

  async put(
    projectId: string,
    body: models.UpCreateCalculationBudgetBodyRow[],
  ): Promise<models.ListCalculationBudgetResponse[]> {
    const calculationBudgets = await appHttpService.request
      .url(`/calculation-budgets/${projectId}`)
      .put(body)
      .json<models.ListCalculationBudgetResponse[]>();
    return calculationBudgets;
  }

  async updateComments(
    projectId: string,
    body: models.UpdateCalculationBudgetCommentBody,
  ) {
    const updatedBudgetRows = await appHttpService.request
      .url(`/calculation-budgets/${projectId}/comments`)
      .put(body)
      .json<models.ListCalculationBudgetResponse[]>();
    return updatedBudgetRows;
  }

  async exportToCsv(projectId: string): Promise<string> {
    const csv = await appHttpService.request
      .url(`/calculation-budgets/${projectId}/export`)
      .post()
      .text();
    return csv;
  }
}

export const calculationBudgetService = new CalculationBudgetService();
